// 全局配置文件

// 从 sessionStorage 获取 BASE_URL，如果不存在则使用默认值
const getStoredUrl = () => {
  return sessionStorage.getItem('baseUrl') || '';
};

// 设置 BASE_URL 并持久化到 sessionStorage
export function setBaseUrl(newUrl) {
  sessionStorage.setItem('baseUrl', newUrl);
}

// 获取 BASE_URL
export function getBaseUrl() {
  return getStoredUrl();
}


